module.exports = __webpack_public_path__ + "img/play.f612ef1.svg";